import { useState, useContext } from 'react';

import { RegisterForm } from '../../Components/RegisterForm';
import { LoginForm } from '../../Components/LoginForm';
import { ProfilePanel } from './ProfilePanel';
import { ProfileUpdateForm } from './ProfileUpdateForm';
import { UserContext } from '../UserContext';

export const ProfilePage = () => {
  const { user } = useContext(UserContext);
  const [showRegister, setShowRegister] = useState(false);

  return (
    <section className="relative h-[calc(100vh-267px)] w-full">
      <div className="bg-cover bg-center bg-hall bg-no-repeat absolute top-0 right-0 bottom-0 left-0 flex justify-center items-center">
        {user ? (
          <div className="bg-transparent w-full h-full flex flex-col items-center justify-center z-30">
            <ProfilePanel />
            <ProfileUpdateForm />
          </div>
        ) : (
          <div className="bg-transparent w-full h-full flex items-center justify-center z-30">
            {showRegister ? <RegisterForm /> : <LoginForm setShowRegister={setShowRegister} />}
          </div>
        )}
      </div>
    </section>
  );
};
